// extracted by mini-css-extract-plugin
export default {"container":"sec_3lz0T"};